var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAltExternalLink = function SvgAltExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1919",
    fillRule: "evenodd",
    d: "M0 .5h6.359v1.23H1.231v13.54h13.538V10.14H16V16.5H0zm13.899 1.23H8.82V.5H16v7.18h-1.23V2.6L8.434 8.935l-.87-.87z",
    clipRule: "evenodd"
  })));
};
export default SvgAltExternalLink;